 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		3: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		3: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "scripts/" + ({"1":"ExampleComponent","2":"PartnerRegistration","5":"AcademyRegistration","6":"ConfigPlus","7":"KnowledgebaseReleaseSearch","8":"BlogReleaseSearch","9":"EventsTeaser","10":"BlogReleaseTeaser","11":"AkademieEventFilter","12":"Magazine","13":"MediaDownloads","14":"Footer","15":"Contact","16":"PressReleases","17":"dhsv-slider","18":"TestimonialSlider","19":"ManufacturerOverview","20":"Header","21":"TabsBlock","22":"JobList","23":"SVG","24":"PortfolioTrial","25":"ContactSweden","27":"VideoSliderItem","28":"AcademyEventTeaserItem","29":"VideoBlock","30":"LocationMap","31":"HeroStageM","32":"HeroStageL","33":"CustomSliderItem","34":"PortfolioTrialSweden","35":"AcademyEventTeaser","37":"DownloadLink","38":"TextImageCta","39":"ExpandableBlock","40":"AnchorNavigation","46":"Button","47":"ImageTag","56":"TabsItemBlock"}[chunkId]||chunkId) + "_" + {"1":"092dfe5df207a90d4bcd","2":"150a292c3e476df6b9b4","5":"a07d7bd490f9a57a3406","6":"31841aa842df2e6c55d5","7":"46833d71227ff6f7977c","8":"16a390d4316e88690b17","9":"0bdbea91e3f55802c0f8","10":"8f91628f2afd92ea8b48","11":"96cd7f4552cf4d18a1bc","12":"e50e33a0e124bd21200c","13":"e720370518dc6134dd64","14":"ee2a1c741f06b708be84","15":"b6473394feec3ac9007b","16":"a8e083738c352572ba2c","17":"ccd0eb84dcef69ff6ac6","18":"c67536ab678c6dcbf515","19":"6412b5a3b40dc93e0fd3","20":"328603d7a9248659f3b9","21":"cdea18bac2356e985bee","22":"dd89960dfbaaca039dc2","23":"d03ebca3a902d13c39ad","24":"da562c6a5f6033c6c521","25":"dbf44f5b0f658cbbb50b","27":"bda85079012317c6e801","28":"5a599384a9ee179954b2","29":"4a5e2c080351ffa37208","30":"c24a77a685546fc2f927","31":"a50d782cbc333676fef3","32":"24c528df1b84570370af","33":"744b9c60e08a61ba2abe","34":"6c3e78e503636681b17a","35":"1425305ccd910ba48e23","36":"828659347d548c5d3afa","37":"f51ed5e4b2b572dd26e9","38":"550fbb6df596c4fff891","39":"fdfc257ff6b3027f5ec6","40":"43b6e8a12ba15fe31ee8","41":"4dbbb06558b463a66de0","42":"0a2417f571f8a98f7ec7","43":"7f9b122a564cdb0367b9","44":"6539e87c0bd19dc68fb6","45":"4534d63e2b5165f55d90","46":"5948628e2056829ea74c","47":"8055ae5525a0e2ab191a","48":"abf8ddee8db7f70ded6c","49":"9bd92706a0593f408caa","50":"eedb2626f77904890383","51":"06a8f7ae4a4dbca31576","52":"efca61cf8fc09febbc5c","53":"036973fe5d69b472d1a4","56":"b37ffcfb43a5145b46e8","57":"7eaf5a80410a101ee62c","59":"32e2a57fd93350b5a57b","60":"b38faf364ec9448aa61a","61":"f38357a5a01160c0e9a6","62":"3a295ccd10ac16ff720b","63":"739c3b635f6d7384423f","64":"340b19845193ab8043c7","65":"6cbc047c565277fff844"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"2":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"51":1,"52":1,"57":1,"60":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "styles/" + ({"1":"ExampleComponent","2":"PartnerRegistration","5":"AcademyRegistration","6":"ConfigPlus","7":"KnowledgebaseReleaseSearch","8":"BlogReleaseSearch","9":"EventsTeaser","10":"BlogReleaseTeaser","11":"AkademieEventFilter","12":"Magazine","13":"MediaDownloads","14":"Footer","15":"Contact","16":"PressReleases","17":"dhsv-slider","18":"TestimonialSlider","19":"ManufacturerOverview","20":"Header","21":"TabsBlock","22":"JobList","23":"SVG","24":"PortfolioTrial","25":"ContactSweden","27":"VideoSliderItem","28":"AcademyEventTeaserItem","29":"VideoBlock","30":"LocationMap","31":"HeroStageM","32":"HeroStageL","33":"CustomSliderItem","34":"PortfolioTrialSweden","35":"AcademyEventTeaser","37":"DownloadLink","38":"TextImageCta","39":"ExpandableBlock","40":"AnchorNavigation","46":"Button","47":"ImageTag","56":"TabsItemBlock"}[chunkId]||chunkId) + "_" + {"1":"1fa874024456664a2f0e","2":"5e24bd2d6cf89d9f9321","5":"a4d2fe7488d9055d2c72","6":"e9f2f76dafdb31f1725a","7":"6389547e9cbfba8b6eed","8":"eb97ae9e9bc7745609e7","9":"964e313ec7c94e4f91c6","10":"7ca76fd0ccd6d4ba31f6","11":"f973f60993a049093787","12":"8f223e891e3c91c6dd47","13":"ff99488fbcfbf6407175","14":"f1ade280fecf9676f206","15":"e0aa608a89c02fd6ee76","16":"dc09a211a7b491e11696","17":"d152b65d3bdbbbc85ce8","18":"6be48b0deeb89a88a529","19":"61c5ed8f258ab59585f0","20":"d5959e2efbc9ba17bf85","21":"f955b67916d504a1f3cd","22":"001e07cd3e8c3cc88e1c","23":"0be2722361036b6bc311","24":"cc9d47273218ca3fe282","25":"91936cba8e94eecda0c4","27":"2c4b521173c41cc3867d","28":"d4388fd0eb136e78650b","29":"df14f2e9246f9d3604a5","30":"f08d6405af0482f247dd","31":"90d3fdd3a86c74757579","32":"711c632f89c32e46341c","33":"e4ad28750da3478008c6","34":"0d816b426420f78c4908","35":"bc39fe78f4032c916edf","36":"c9fe6c3def90daef3ef7","37":"5b900b4a4afcb5260757","38":"a6b1f73fe33d73744836","39":"8fb1635c472664c5aa32","40":"05800685b251e92e10da","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"e0983509b91c26fe4a20","52":"91936cba8e94eecda0c4","53":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"5ea9bb0495cf2109b0b3","59":"31d6cfe0d16ae931b73c","60":"e68a375e6afb1a3cb353","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/wp-content/themes/360vier-theme/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,58]);
 	// run deferred modules when ready
 	return checkDeferredModules();
